<template>
  <a class="zt-title" :href="href" :target="target" v-if="href">
    <slot name="before"></slot>
    <slot>{{ title }}</slot>
    <span class="after">
      <slot name="after"></slot>
    </span>
  </a>
  <p class="zt-title" v-else>
    <slot name="before"></slot>
    <slot>{{ title }}</slot>
    <span class="after">
      <slot name="after"></slot>
    </span>
  </p>
</template>

<script>
export default {
  name: 'ZtTitle',
  props: {
    href: String,
    target: String,
    title: String,
  },
}
</script>

<style lang="scss" scoped>
.zt-title {
  color: inherit;
  display: block;
  font-weight: bold;
  font-size: 18px;
  line-height: 44px;
  height: 44px;
  margin: 0;
  padding: 0;
}
.after {
  float: right;
  line-height: 1.4;
}
</style>
